import QuizPopup from "./QuizPopup";
import React, { useState } from "react";
import * as motion from "motion/react-client";
import StickyNavbar from "../navbar";
import { Link } from "react-router-dom";
import malaysia from "../images/malaysia.svg";
import malay from "../images/malay.svg";
import fyp from "../images/fyp.svg";
import fypinfo from "../images/fypinfo.svg";
import work from "../images/work.svg";
import workinfo from "../images/workinfo.svg";

const Chapter7SectionThree = () => {
    const [showQuiz, setShowQuiz] = useState(false);
    
      const handleQuizComplete = (answers) => {
        console.log("User answers:", answers);
        // You can process the answers here
      };
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <div>
      <StickyNavbar />
      <div className="bg-white text-lg text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20">
        <motion.div
          className="mb-8 space-y-5"
          initial="hidden"
          animate="visible"
          variants={fadeIn}
        >
          <motion.h1
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center capitalize"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            Who should you share your research with?
          </motion.h1>

          <motion.p className=" py-5 text-lg" variants={fadeIn}>
            What you have learned from doing your research will be valuable to
            the community, other healthcare facilities and workers, and local
            governments who have the power to make important decisions. It is
            important to share your findings in ways that are clear, easy to
            access, and in ways people can act upon them.
          </motion.p>

          <motion.div className="grid grid-cols-2 gap-4">
            <motion.img src={malaysia} alt="malaysia" className="w-full" />
       
            <motion.img src={fyp} alt="fyp" className="w-full" />
            <motion.img src={malay} alt="malay" className="w-full" />
            <motion.img src={fypinfo} alt="fypinfo" className="w-full" />
          </motion.div>
          <motion.p className=" py-5 text-lg" variants={fadeIn}>
            Engaging the community
          </motion.p>
          <motion.p className=" py-5 text-lg" variants={fadeIn}>
            If your research involves members of the community, it’s both
            respectful and valuable to share your findings with them. Doing this
            will help to build trust and good working relationships with the
            community. These growing connections are also important if you want
            to do further research with the community later; if you keep people
            informed from start to finish, they are more likely to engage with
            you in the future.
          </motion.p>
          <motion.p className=" py-5 text-lg" variants={fadeIn}>
            Here are some ways that you might do this:
          </motion.p>
          <ul className="list-disc list-inside space-y-3">
            <li>
              <span className=" font-medium text-lg "> Community meetings: </span>
              You could organise meetings where your findings can be explained
              in simple and understandable ways. Community members can ask
              questions, share their thoughts, and offer feedback.
            </li>
            <li>
              {" "}
              <span className=" font-medium text-lg"> Use visual tools:</span>
              Some of your data might be a bit complicated, so using
              presentations, charts, graphs, posters, or other visuals will help
              to explain what you have found in an engaging and manageable way
              to those who may not be familiar with research.{" "}
            </li>
          </ul>
          <motion.p className=" py-5 text-lg" variants={fadeIn}>
            Beyond the community:
          </motion.p>
          <ul className="list-disc list-inside space-y-3">
            <li>
              <span className=" font-medium text-lg">
                Involve local leaders:
              </span>
              : Together with your colleagues, you could find ways of getting
              in contact with and working with local leaders, such as community
              leaders and people in local government. Their support can help you
              to spread your findings and your message further, while
              encouraging more people to engage with it.
            </li>
            <li>
              {" "}
              <span className=" font-medium text-lg">
                {" "}
                Present findings to officials:
              </span>
              You could put together a brief summary of your findings in a
              report or presentation, and work on tailoring it to people who
              create policies, focusing on how your results and what you have
              found can guide decisions to improve public health.
            </li>
            <li>
              {" "}
              <span className=" font-medium text-lg">
                {" "}
                Advocate for action:
              </span>
              If what you have found during your research suggests that there
              are gaps in services, or processes that could be improved, you can
              use this evidence to push for change. This might mean approaching
              community groups or organisations and working with them, or
              sharing your findings with local media.
            </li>
          </ul>
          {/* <div>
            <p className=" text-2xl font-medium text-[#005FFF]">
              Who should you share your research with?
            </p>
            <p className="mt-3">
              You likely won’t carry out a research project or its dissemination
              on your own—it’s a team effort. Sharing the process with your
              colleagues and other facilities means it can be more manageable,
              and is likely to have more impact. By working together, you can
              combine resources, share tasks, and make sure your findings reach
              more people. Collaborating in this way not only makes
              dissemination easier, but also makes sure the process benefits
              more people in the community and beyond.
            </p>
          </div> */}
          {/* <div>
            <p className=" text-2xl font-medium text-[#005FFF]">
              Collaborating with other healthcare facilities
            </p>
            <p>
              Research can often have an impact on more than just one community;
              it is likely that other communities and other facilities share an
              interest in learning more about similar topics to you. Issues that
              are affecting your community may be affecting them too
            </p>
            <ul className="list-disc list-inside space-y-5"></ul>
            <li>
              <span className=" font-medium text-lg">
                {" "}
                Joint dissemination projects:
              </span>
              Smaller facilities can collaborate to combine resources and carry
              out larger dissemination events. For example, if your facility is
              small, working with a larger one to disseminate your research
              means you will be able to do more and increase the impact of your
              research, because you have access to more resources.
            </li>
            <li>
              <span className=" font-medium text-lg">
                {" "}
                Sharing your research with other facilities:
              </span>
              Even if you do not collaborate with other healthcare facilities,
              you can still share your findings with them so that they can
              benefit too. This could include arranging presentations,
              workshops, or creating shared reports that can be handed out to
              healthcare workers in similar settings.
            </li>
          </div> */}
          <div>
            <p className=" text-2xl text-[#005FFF] font-medium">Why dissemination matters</p>
            <p>
              Dissemination is the bridge between research and action, and the
              process that means that what you have found can help to make
              important changes. By sharing what you have found, and sharing it
              with the right people:
            </p>
            <ul className="list-disc list-inside space-y-5"></ul>
            <li>
              Communities can learn from the research and make informed health
              choices.
            </li>
            <li>Healthcare workers can improve their practices.</li>
            <li>
              Local governments can use the information to create or improve
              policies.
            </li>
            <li>
              More people will have better access to good quality healthcare.
            </li>
          </div>
          <div className="m-auto  ">
          <motion.img src={work} alt="malaysia" className="m-auto w-2/4" />
       <motion.img src={workinfo} alt="fyp" className="m-auto w-2/4" />   
       </div>
        </motion.div>
        <div className="flex justify-between mt-10">
          <Link to="/chapter7/sectionTwo">
            <button className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700">
              Previous
            </button>
          </Link>
          <div className="flex justify-center ">
          <button
            onClick={() => setShowQuiz(true)}
            className="bg-white text-blue-800 border border-blue-800 px-3 py-2 rounded-lg "
          >
            Test Your Knowledge
          </button>
        </div>
          <Link to="/references">
            <button className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700">
              Next
            </button>
          </Link>
        </div>
      </div>
      {showQuiz && (
        <QuizPopup
          onClose={() => setShowQuiz(false)}
          onComplete={handleQuizComplete}
        />
      )}
    </div>
  );
};

export default Chapter7SectionThree;
